module.exports = __webpack_public_path__ + "img/10.26acc617.png";